import { QueryClient } from "@tanstack/react-query";
import { Col, Form, Input, Modal, notification, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import {
  useInventoryServiceCreateModel,
  useInventoryServiceGetModelsKey,
} from "api/queries";
import { useEffect } from "react";

interface ICreateProductModelModalProps {
  isOpen: boolean;
  onClose: () => void;
  queryClient: QueryClient;
}

const CreateProductModelModal: React.FC<ICreateProductModelModalProps> = ({
  isOpen,
  onClose,
  queryClient,
}) => {
  const [form] = Form.useForm();

  const { mutate, isPending } = useInventoryServiceCreateModel({
    onError: (error: any) => {
      notification.error({
        description: error?.body?.message || error?.response?.data?.message || error?.message,
        type: "error",
        message: "Failed to create model",
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [useInventoryServiceGetModelsKey],
        refetchType: "all",
      });
      form.resetFields();
      onClose();
    },
  });

  const handleSubmit = (values: any) => {
    mutate({
      requestBody: values,
    });
  };

  useEffect(() => {
    form.resetFields();
  }, [isOpen]);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title="Create Model"
      onOk={() => form.submit()}
      okButtonProps={{ loading: isPending }}
      cancelButtonProps={{ disabled: isPending }}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        name="create-model-form"
      >
        <Row gutter={16}>
          <Col xs={24}>
            <Form.Item
              name="modelName"
              label="Model Name"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item name="modelDescription" label="Description">
              <TextArea />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default CreateProductModelModal;
